import * as aor from "react-admin";
import React from "react";
import { getUserCompany, getPolicies } from "../common/authClient";
import myRestClient from "../common/restClient";
import { POLICY_ROLE_MAPPINGS } from "../common/rolesManagement";
import { withStyles } from "@material-ui/core/styles";
import { PER_PAGE_MAX_LIMIT } from "../config";

const styles = theme => ({});
class RestrictedEditButton extends React.Component {
    state = { visible: false, disabled: false };

    componentDidMount() {
        const policies = getPolicies();

        const params = {
            filter: { company_to_edit_id: getUserCompany() },
            pagination: { page: 1, perPage: PER_PAGE_MAX_LIMIT },
            sort: { field: "name", order: "asc" }
        };
        myRestClient("GET_LIST", "roles", params).then(
            result => {
                if (policies.includes(POLICY_ROLE_MAPPINGS.UPDATE)) {
                    let disabled = false;
                    if (result && result.data) {
                        result = result.data.map(r => {
                            return r.id;
                        });
                        const role = this.props.record.role_id;
                        if (role && !result.includes(role)) {
                            disabled = true;
                        }
                    }
                    this.setState({ visible: true, disabled: disabled });
                } else {
                    this.setState({ visible: false, disabled: true });
                }
            },
            error => {
                console.log(error);
                this.setState({ visible: false, disabled: true });
            }
        );
    }

    render() {
        if (this.state.visible) {
            return (
                <aor.EditButton
                    disabled={this.state.disabled}
                    basePath={this.props.basePath}
                    record={this.props.record}
                />
            );
        } else {
            return <span />;
        }
    }
}

export default withStyles({ styles })(RestrictedEditButton);



// WEBPACK FOOTER //
// ./src/components/RestrictedEditButton.js